import React, { useEffect, useState, useContext, useRef } from 'react';
import ContentMarkDown from './ContentMarkDown';
import DataContext from '../../hooks/DataContext.js';
import RelativePosts from './RelativePosts';
import { Disqus } from 'gatsby-plugin-disqus';
import { useLanguage } from '../../locales';
import {
  clearUrl,
  getScrollbarHeight,
  getDeviceType,
} from '../../utils/helperFunctions';
import Moment from 'react-moment';
import { BsPencilSquare, BsCalendar, BsEye } from 'react-icons/bs';
import { increasePostView } from '../../database/post';
import Divider from '@material-ui/core/Divider';
import { getPostViews } from '../../database/post';
import { useTheme } from '../../theme';
import {
  Wrapper,
  Title,
  Description,
  DescriptionItem,
  Beside,
} from './styles/Post.styles';

const setMainContentsOfPost = () => {
  const anchors = document.querySelectorAll('h2, h3, h4');
  let listMainContentsOfPost = [];
  const plusMorePixels = getDeviceType() === 'mobile' ? 100 : 65;
  const scrollbarHeight = Math.max(getScrollbarHeight() + plusMorePixels, 50);
  for (let i = 0; i < anchors.length; i++) {
    const anchor = anchors[i];
    if (anchor.getAttribute('id')) {
      const _id = anchor.getAttribute('id');
      listMainContentsOfPost.push({
        id: _id,
        text: anchor.innerText,
        nodeType: anchor.tagName.toLowerCase(),
        offsetTopStart:
          i === 0
            ? 0
            : document.getElementById(_id).offsetTop - scrollbarHeight,
      });
    }
  }
  return listMainContentsOfPost;
};

const Post = ({ post }) => {
  const { lang, translation } = useLanguage();
  const [postViews, setPostViews] = useState(null);
  const { setHeadings, setReadProgress } = useContext(DataContext);
  const postEndRef = useRef(null);
  const { theme } = useTheme();
  useEffect(() => {
    // set main contents of post
    setTimeout(() => {
      const listMainContentsOfPost = setMainContentsOfPost();
      const headingsCascade = [];
      for (let i = 0; i < listMainContentsOfPost.length; i++) {
        const currentHeading = listMainContentsOfPost[i];
        const nextHeading = listMainContentsOfPost[i + 1];
        if (nextHeading)
          currentHeading.offsetTopEnd = nextHeading.offsetTopStart;
        else currentHeading.offsetTopEnd = Infinity;
        if (currentHeading.nodeType === 'h2')
          headingsCascade.push({ ...currentHeading, children: [] });

        if (currentHeading.nodeType === 'h3') {
          const h2Cascade = headingsCascade;
          const lastH2Cascade = h2Cascade[h2Cascade.length - 1];
          const lastH2CascadeChildren = lastH2Cascade.children;
          lastH2CascadeChildren.push({ ...currentHeading, children: [] });
          //update offsetTopEnd of h2 parent
          lastH2Cascade.offsetTopEnd = currentHeading.offsetTopEnd;
        }
        if (currentHeading.nodeType === 'h4') {
          const h2Cascade = headingsCascade;
          const lastH2Cascade = h2Cascade[h2Cascade.length - 1];
          const h3Cascade = lastH2Cascade.children;
          const lastH3Cascade = h3Cascade[h3Cascade.length - 1];
          const lastH3CascadeChildren = lastH3Cascade.children;
          lastH3CascadeChildren.push({ ...currentHeading });
          //update offsetTopEnd of h2 parent
          lastH2Cascade.offsetTopEnd = currentHeading.offsetTopEnd;
          lastH3Cascade.offsetTopEnd = currentHeading.offsetTopEnd;
        }
      }
      setHeadings([...headingsCascade]);
    }, 0);
  }, [lang]);

  useEffect(() => {
    let timer;
    timer = setTimeout(() => {
      increasePostView(post.contentful_id);
    }, 6000);

    getPostViews(post.contentful_id)
      .then((res) => setPostViews(res))
      .catch((err) => console.log(err));
    return () => clearTimeout(timer);
  }, []);

  const disqusConfig = {
    shortname: process.env.GATSBY_DISQUS_NAME,
    config: {
      url: `${process.env.GATSBY_SITE_URL}/posts/${clearUrl(post.slug)}`,
      identifier: post.contentful_id,
      title: post.title_vi,
    },
  };
  useEffect(() => {
    const { scrollTop } = document.documentElement;
    const postEndOffsetTop = postEndRef?.current?.offsetTop;
    if (postEndOffsetTop && scrollTop && postEndOffsetTop >= scrollTop) {
      let progress = Math.ceil((scrollTop / postEndOffsetTop) * 100);
      if (progress > 100) {
        progress = 100;
      }
      setReadProgress(progress);
    }
  });
  return (
    <Wrapper>
      <Title>{post[`title_${lang}`]}</Title>
      <Description theme={theme}>
        <DescriptionItem>
          <BsPencilSquare />
          <span>{post.author}</span>
        </DescriptionItem>
        <DescriptionItem>
          <BsCalendar />
          <Moment format="LL" locale={lang}>
            {post.updatedAt}
          </Moment>
        </DescriptionItem>
        <DescriptionItem>
          <BsEye />
          <span>
            {postViews ? postViews : translation.posts.postViewsUndefined}
          </span>
        </DescriptionItem>
      </Description>

      <ContentMarkDown post={post[`body_${lang}`][`body_${lang}`]} />
      <Beside ref={postEndRef}>
        <RelativePosts post={post} />
        <Disqus {...disqusConfig} />
      </Beside>
      <Divider />
    </Wrapper>
  );
};

export default Post;
